import { initializeApp, getApps, getApp, type FirebaseOptions } from "firebase/app";

import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, signOut, createUserWithEmailAndPassword } from "firebase/auth";
import config from "../boot/config";

const googleProvider = new GoogleAuthProvider();
const firebaseConfig: FirebaseOptions = {
  apiKey: config.firebaseConfig.apiKey,
  authDomain: config.firebaseConfig.authDomain,
  projectId: config.firebaseConfig.projectId,
  storageBucket: config.firebaseConfig.storageBucket,
  messagingSenderId: config.firebaseConfig.messagingSenderId,
  appId: config.firebaseConfig.appId,
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

export { app, auth, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, googleProvider, signOut, createUserWithEmailAndPassword };
